(function () {
    'use strict';

    /* ===== Forecast model — calibrated against company averages + NIH/ACSM. =====
     * Mirrors inc/blocks/class-weight-loss-forecast.php (tempo() / z_dietetykiem())
     * exactly. Do not change these values or formulas without mirroring the PHP side. */
    const TYG = 4.345;
    const MNOZ = [1.15, 1.00, 0.92, 0.85, 0.79, 0.74];
    const APP = [0.47, 0.35, 0.21, 0.11, 0.05, 0.00];
    const SOLO = [1.00, 0.62, 0.04, -0.32, -0.47, -0.50];
    const BMI_MIN = 21;
    const BMI_FLOOR = 18.6;

    function tempo(bmi, plec) {
        let r;
        if (bmi < 25) r = 0.39;
        else if (bmi < 30) r = 0.39 + (bmi - 25) / 5 * 0.25;
        else if (bmi < 35) r = 0.64 + (bmi - 30) / 5 * 0.15;
        else if (bmi < 40) r = 0.79 + (bmi - 35) / 5 * 0.06;
        else r = 0.80;
        if (plec === 'm') r *= 1.08;
        return r;
    }

    function zDietetykiem(w0, h, p) {
        const fl = BMI_FLOOR * Math.pow(h / 100, 2), o = [w0]; let w = w0;
        for (let m = 0; m < 6; m++) {
            const r = tempo(w / Math.pow(h / 100, 2), p) / 100 * TYG * MNOZ[m];
            let n = w * (1 - r); if (n < fl) n = Math.max(fl, w - (w - fl) * 0.55);
            w = n; o.push(w);
        }
        return o;
    }

    function scenariusz(w0, h, p, M, cap) {
        const fl = BMI_FLOOR * Math.pow(h / 100, 2), o = [w0]; let w = w0;
        const b = tempo(w0 / Math.pow(h / 100, 2), p) / 100 * TYG;
        for (let m = 0; m < 6; m++) {
            let n = w * (1 - b * M[m]);
            if (n < fl) n = fl; if (cap) n = Math.min(n, w0 * 1.02);
            w = n; o.push(w);
        }
        return o;
    }

    const f = (n, d = 1) => n.toFixed(d).replace('.', ',');
    const mobile = () => window.innerWidth <= 700;

    function pushDataLayer(payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    }

    function initInstance(root) {
        let config = {};
        try {
            config = JSON.parse(root.dataset.config || '{}');
        } catch (e) {
            config = {};
        }
        const plany = config.plany || {};
        const ctaHref = config.ctaHref || '#packages';
        const pakietNazwa = config.pakiet || '';

        const q = (sel) => root.querySelector(sel);
        const qa = (sel) => root.querySelectorAll(sel);

        const heightInput = q('.js-height');
        const weightInput = q('.js-weight');
        const chartEl = q('.js-chart');

        if (!heightInput || !weightInput || !chartEl) return;

        const titleId = chartEl.dataset.titleId || 'cT';
        const brandOrange = (getComputedStyle(root).getPropertyValue('--color-primary') || '').trim() || '#F97316';

        const S = { plec: 'k', wzrost: +heightInput.value, waga: +weightInput.value, plan: 6 };

        let interacted = false;
        let viewed = false;

        function trackInteraction(pole) {
            if (interacted) return;
            interacted = true;
            pushDataLayer({ event: 'kalkulator_interakcja', pole: pole });
        }

        function limity() {
            const minW = Math.ceil(BMI_MIN * Math.pow(S.wzrost / 100, 2));
            const maxH = Math.floor(Math.sqrt(S.waga / BMI_MIN) * 100);
            weightInput.min = Math.max(+weightInput.dataset.min, minW);
            heightInput.max = Math.min(+heightInput.dataset.max, maxH);
        }

        function render() {
            const D = zDietetykiem(S.waga, S.wzrost, S.plec);
            const A = scenariusz(S.waga, S.wzrost, S.plec, APP, false);
            const B = scenariusz(S.waga, S.wzrost, S.plec, SOLO, true);

            const p = S.plan, endW = D[p], ut = S.waga - endW;
            const planCfg = plany[p] || {};
            const cenaM = planCfg.cena || 0;
            const total = planCfg.total || 0;

            q('.js-lbl').textContent = 'Z dietetykiem, po ' + (p === 1 ? 'miesiącu' : p + ' miesiącach');
            q('.js-kg').textContent = f(ut);
            q('.js-endW').textContent = f(endW);
            q('.js-pkgPrice').textContent = pakietNazwa + ' — ' + cenaM + ' zł / mies.';
            q('.js-costKg').textContent = ut > 0 ? Math.round(total / ut) : 0;
            q('.js-cta').href = ctaHref;

            const soloKg = S.waga - B[6];
            const iMin = B.indexOf(Math.min(...B));
            const jojo = B[6] - B[iMin] > 0.8 && iMin > 0 && iMin < 6;
            const deltaKg = B[6] - D[6];

            q('.js-mleg').innerHTML =
                '<div class="d"><i></i><span>Z dietetykiem</span><b>−' + f(S.waga - D[6]) + ' kg</b></div>' +
                '<div class="a"><i></i><span>Sama aplikacja</span><b>−' + f(S.waga - A[6]) + ' kg</b></div>' +
                '<div class="s"><i></i><span>Samodzielnie' + (jojo ? '<b class="jj">efekt jo-jo</b>' : '') + '</span><b>' + (soloKg >= 0.05 ? '−' : '') + f(Math.abs(soloKg)) + ' kg</b></div>' +
                '<p class="weight-loss-forecast__legend-delta">Z dietetykiem tracisz o <b>' + f(deltaKg) + ' kg więcej</b> niż samodzielnie.</p>';

            rysuj(D, A, B, jojo, iMin);
        }

        function rysuj(D, A, B, jojo, iMin) {
            const M = mobile();
            const W = M ? 400 : 660, H = M ? 300 : 360;
            const pL = M ? 34 : 44, pR = M ? 18 : 138, pT = M ? 16 : 20, pB = M ? 30 : 34;
            const iw = W - pL - pR, ih = H - pT - pB;
            const all = D.concat(A, B);
            let min = Math.min(...all), max = Math.max(...all);
            const mg = Math.max((max - min) * 0.12, 1); min -= mg; max += mg;
            const X = i => pL + (i / 6) * iw, Y = w => pT + (1 - (w - min) / (max - min)) * ih;
            const path = a => a.map((w, i) => (i ? 'L' : 'M') + X(i).toFixed(1) + ' ' + Y(w).toFixed(1)).join(' ');
            const F = 'Poppins,sans-serif';
            const fs = M ? 13 : 12;

            chartEl.setAttribute('viewBox', `0 0 ${W} ${H}`);

            let g = `<defs><linearGradient id="fl-${titleId}" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="${brandOrange}" stop-opacity=".16"/>
                <stop offset="100%" stop-color="${brandOrange}" stop-opacity="0"/></linearGradient></defs>`;

            for (let i = 0; i <= 3; i++) {
                const y = pT + i * (ih / 3), v = max - i * ((max - min) / 3);
                g += `<line x1="${pL}" y1="${y}" x2="${W - pR}" y2="${y}" stroke="#F4EAE2" stroke-width="1"/>`;
                g += `<text x="${pL - 8}" y="${y + 5}" text-anchor="end" font-size="${fs}" fill="#B8AAA1" font-family="${F}">${v.toFixed(0)}</text>`;
            }
            g += `<rect x="${X(0)}" y="${pT}" width="${X(S.plan) - X(0)}" height="${ih}" fill="#FFF3EA" opacity=".8"/>`;

            g += `<path d="${path(B)}" fill="none" stroke="#BFB2A9" stroke-width="${M ? 2.4 : 2.6}" stroke-dasharray="6 6" stroke-linecap="round" stroke-linejoin="round"/>`;
            g += `<path d="${path(A)}" fill="none" stroke="#8A7C74" stroke-width="${M ? 2.6 : 2.8}" stroke-linecap="round" stroke-linejoin="round"/>`;
            g += `<path d="${path(D) + ` L ${X(6).toFixed(1)} ${pT + ih} L ${X(0).toFixed(1)} ${pT + ih} Z`}" fill="url(#fl-${titleId})"/>`;
            g += `<path d="${path(D)}" fill="none" stroke="${brandOrange}" stroke-width="${M ? 3.6 : 4}" stroke-linecap="round" stroke-linejoin="round"/>`;

            /* etykiety przy liniach — tylko desktop; na mobile zastępuje je legenda pod wykresem */
            if (!M) {
                const lab = [
                    { y: Y(D[6]), c: brandOrange, t: ['Z dietetykiem'], kg: '−' + f(S.waga - D[6]) + ' kg', w: 600, s: 15 },
                    { y: Y(A[6]), c: '#8A7C74', t: ['Sama aplikacja'], kg: '−' + f(S.waga - A[6]) + ' kg', w: 500, s: 13.5 },
                    { y: Y(B[6]), c: '#A2948B', t: ['Samodzielnie'], kg: (S.waga - B[6] >= 0.05 ? '−' : '') + f(Math.abs(S.waga - B[6])) + ' kg', w: 500, s: 13.5 }
                ].sort((a, b) => a.y - b.y);
                const wys = l => l.t.length * 14 + 19;
                for (let i = 1; i < lab.length; i++) {
                    const minY = lab[i - 1].y + wys(lab[i - 1]) + 8;
                    if (lab[i].y < minY) lab[i].y = minY;
                }
                lab.forEach(l => {
                    l.t.forEach((line, i) => {
                        g += `<text x="${W - pR + 14}" y="${l.y - 4 + i * 14}" font-size="11.5" font-weight="500" fill="${l.c}" font-family="${F}">${line}</text>`;
                    });
                    g += `<text x="${W - pR + 14}" y="${l.y + l.t.length * 14 + 1}" font-size="${l.s}" font-weight="${l.w}" fill="${l.c}" font-family="${F}">${l.kg}</text>`;
                });
            }

            g += `<circle cx="${X(6)}" cy="${Y(B[6])}" r="4" fill="#BFB2A9"/>`;
            g += `<circle cx="${X(6)}" cy="${Y(A[6])}" r="4" fill="#8A7C74"/>`;
            D.forEach((w, i) => {
                const on = i === S.plan;
                g += `<circle cx="${X(i)}" cy="${Y(w)}" r="${on ? (M ? 6 : 7) : 4}" fill="${on ? brandOrange : '#fff'}" stroke="${brandOrange}" stroke-width="${on ? 3 : 2.6}"/>`;
            });

            if (!M && jojo)
                g += `<text x="${X(iMin) + 6}" y="${Y(B[iMin]) + 20}" font-size="12" fill="#A2948B" font-family="${F}" font-style="italic">efekt jo-jo</text>`;

            for (let i = 0; i <= 6; i++) {
                if (M && i % 2 === 1 && i !== S.plan) continue;   /* na wąskim ekranie co druga podziałka */
                g += `<text x="${X(i)}" y="${H - 8}" text-anchor="middle" font-size="${fs}" fill="#B8AAA1" font-family="${F}">${i === 0 ? 'start' : i + ' mies.'}</text>`;
            }

            chartEl.innerHTML = `<title id="${titleId}">Porównanie scenariuszy redukcji</title>` + g;
        }

        [[heightInput, 'wzrost', 'wzrost'], [weightInput, 'waga', 'masa']].forEach(([el, key, pole]) => {
            const out = el === heightInput ? q('.js-hV') : q('.js-wV');
            el.addEventListener('input', () => {
                const v = +el.value;
                S[key] = v; out.textContent = v;
                if (v === +el.min || v === +el.max) {
                    el.classList.add('atlimit');
                    clearTimeout(el._t);
                    el._t = setTimeout(() => el.classList.remove('atlimit'), 450);
                }
                trackInteraction(pole);
                limity(); render();
            });
        });

        qa('[data-sex]').forEach(b => b.addEventListener('click', () => {
            qa('[data-sex]').forEach(x => x.setAttribute('aria-pressed', 'false'));
            b.setAttribute('aria-pressed', 'true'); S.plec = b.dataset.sex;
            trackInteraction('plec');
            render();
        }));

        qa('[data-m]').forEach(b => b.addEventListener('click', () => {
            qa('[data-m]').forEach(x => x.setAttribute('aria-pressed', 'false'));
            b.setAttribute('aria-pressed', 'true'); S.plan = +b.dataset.m;
            pushDataLayer({ event: 'kalkulator_pakiet', okres: S.plan });
            render();
        }));

        const ctaEl = q('.js-cta');
        if (ctaEl) {
            ctaEl.addEventListener('click', () => {
                const D = zDietetykiem(S.waga, S.wzrost, S.plec);
                const prognozaKg = +(S.waga - D[S.plan]).toFixed(1);
                const bmiStart = +(S.waga / Math.pow(S.wzrost / 100, 2)).toFixed(1);
                pushDataLayer({
                    event: 'kalkulator_cta',
                    okres: S.plan,
                    prognoza_kg: prognozaKg,
                    bmi_start: bmiStart
                });
            });
        }

        if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !viewed) {
                        viewed = true;
                        pushDataLayer({ event: 'kalkulator_view' });
                        io.disconnect();
                    }
                });
            }, { threshold: 0.5 });
            io.observe(root);
        }

        let rt;
        window.addEventListener('resize', () => {
            clearTimeout(rt);
            rt = setTimeout(render, 150);
        });

        limity();
        render();
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.weight-loss-forecast').forEach(initInstance);
    });
})();
